const getTitle = state => state.title
const getSectionSize = state => state.sections.length
const getSections = state => state.sections
const getCurrentSection = state => state.currentSection

export default {
  getTitle,
  getSectionSize,
  getSections,
  getCurrentSection
}



// WEBPACK FOOTER //
// ./src/store/modules/sections/getters.js